import React from "react";
import { RootTypeProvider } from "../rootTypes/context/RootTypeContext";
import { LocationsPage } from "./LocationsPage";
import { LocationProvider } from "./context/Location";
import { LocationTypeProvider } from "./context/LocationType";

const Location = () => {
	return (
		<LocationProvider>
			<LocationTypeProvider>
				<RootTypeProvider>
					<LocationsPage />
				</RootTypeProvider>
			</LocationTypeProvider>
		</LocationProvider>
	);
};

export default Location;
